import React from 'react'
import InsertTemplateIcon from '../../../assets/InsertTemplate'
import MessageOptionsModal from '../../../Messages/MessageOptionsModal'

import classnames from 'classnames/bind'
import css from './styles.css'

const cx = classnames.bind(css)

const EmailTemplateButton = ({
  openOptionsModal,
  handleTemplateSelection,
  optionsModalOpen,
  closeOptionsModal,
  openCreateTemplateModal,
  createModalOpen,
  saveTemplate,
  setTemplateName,
  templateName,
  templateSettings,
  hideImgPicker,
  isEmail,
}) => {
  const buttonWrapper = cx(css.buttonWrapper)
  const buttonStyle = cx(css.openOptionsButton)
  return (
    <div className={buttonWrapper}>
      <button onClick={openOptionsModal} className={buttonStyle}>
        <InsertTemplateIcon />
      </button>
      {optionsModalOpen && (
        <MessageOptionsModal
          openCreateTemplateModal={openCreateTemplateModal}
          createModalOpen={createModalOpen}
          handleTemplateSelection={handleTemplateSelection}
          closeOptionsModal={closeOptionsModal}
          hideImgPicker={hideImgPicker}
          isEmail={isEmail}
          saveTemplate={saveTemplate}
          setTemplateName={setTemplateName}
          templateName={templateName}
          templateSettings={templateSettings}
        />
      )}
    </div>
  )
}

export default EmailTemplateButton



// WEBPACK FOOTER //
// ./src/components/sitewide/RichTextEditor/StyleControls/EmailTemplateButton.js